import React, { useEffect } from "react";

export const FilmGrain = () => {
  useEffect(() => {
    document.documentElement.classList.add("grain");
    return () => document.documentElement.classList.remove("grain");
  }, []);
  return null;
};

export default FilmGrain;
